export default "__VITE_ASSET__fJd24yZL__"